import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useStore } from "@/context/StoreContext";

const NAV = [
  { to: "/shop", label: "The Drop" },
  { to: "/contact", label: "Contact" },
];

export const Logo = ({ className = "" }) => (
  <span className={`font-display font-extrabold tracking-[0.12em] uppercase ${className}`}>
    SPICY<span className="text-[#ff2a2a]">3D</span> WORLD
  </span>
);

export default function Header() {
  const { count, setOpen } = useCart();
  const { settings } = useStore();
  const [scrolled, setScrolled] = useState(false);
  const [menu, setMenu] = useState(false);

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <header className="sticky top-0 z-50">
      {settings?.announcement && (
        <div data-testid="announcement-bar" className="bg-[#ff2a2a] text-white text-center text-[11px] tracking-[0.2em] uppercase py-2 px-4 font-mono-ui">
          {settings.announcement}
        </div>
      )}
      <div className={`transition-colors duration-500 border-b ${scrolled || menu ? "bg-black/85 backdrop-blur-xl border-white/10" : "bg-black/40 backdrop-blur-md border-transparent"}`}>
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <button className="md:hidden text-white" onClick={() => setMenu(!menu)} data-testid="mobile-menu-button" aria-label="Menu">
            {menu ? <X size={20} /> : <Menu size={20} />}
          </button>
          <Link to="/" data-testid="header-logo" className="text-white text-sm sm:text-base">
            <Logo />
          </Link>
          <nav className="hidden md:flex items-center gap-10 absolute left-1/2 -translate-x-1/2">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) => `text-[11px] tracking-[0.25em] uppercase transition-colors ${isActive ? "text-white" : "text-zinc-400 hover:text-white"}`}>
                {n.label}
              </NavLink>
            ))}
          </nav>
          <button onClick={() => setOpen(true)} data-testid="header-cart-button" className="relative text-white p-2 -mr-2" aria-label="Cart">
            <ShoppingBag size={20} strokeWidth={1.5} />
            {count > 0 && (
              <span data-testid="header-cart-count" className="absolute -top-0.5 -right-0.5 bg-[#ff2a2a] text-white text-[10px] font-bold rounded-full h-4 min-w-4 px-1 flex items-center justify-center">
                {count}
              </span>
            )}
          </button>
        </div>
        {menu && (
          <nav className="md:hidden px-5 pb-6 pt-2 flex flex-col gap-5" data-testid="mobile-menu">
            {[{ to: "/", label: "Home" }, ...NAV].map((n) => (
              <Link key={n.to} to={n.to} onClick={() => setMenu(false)} className="text-sm tracking-[0.25em] uppercase text-zinc-300 hover:text-white">
                {n.label}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}
